export function getElement<T extends HTMLElement>(id: string, type: new() => T): T {
  const el = document.getElementById(id);
  if (!(el instanceof type)) {
    throw new Error(`Element #${id} not found or wrong type (expected ${type.name})`);
  }
  return el;
}

export function getElementOrNull<T extends HTMLElement>(id: string, type: new() => T): T | null {
  const el = document.getElementById(id);
  if (el === null) return null;
  if (!(el instanceof type)) return null;
  return el;
}

export function createSelectAtSlot(
  slotId: string,
  selectId: string,
  options: { value: string; text: string }[],
  attrs?: Record<string, string>,
): HTMLSelectElement | null {
  const slot = document.getElementById(slotId);
  if (!slot) return null;
  const select = document.createElement('select');
  select.id = selectId;
  if (attrs) {
    for (const [key, val] of Object.entries(attrs)) {
      select.setAttribute(key, val);
    }
  }
  for (const opt of options) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.text;
    select.appendChild(option);
  }
  slot.replaceWith(select);
  return select;
}
